<template>
  <div class="card mb-5 mb-xxl-8">
    <div class="card-body pb-0">
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('shop.user_list') }}</h3>
        </div>
        <div class="card-toolbar" v-if="!shop?.archive">
          <button
              v-if="$can('user_boutique_create')"
              @click="openCreateModal"
              class="btn btn-sm btn-primary"
          >{{ $t('button.add') }}</button>
        </div>

      </div>
      <div class="card-body">
        <div class="row">
          <table class="table align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_shop_user">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-100px">{{ $t('shop.user_lastname') }}</th>
                <th class="min-w-100px">{{ $t('shop.user_firstname') }}</th>
                <th class="min-w-100px">{{ $t('shop.user_role') }}</th>
                <th class="min-w-100px">{{ $t('action') }}</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>

    <div class="modal fade" id="createModal" data-backdrop="static" tabindex="-1" role="dialog"
      aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog">
        <form @submit.prevent="addUsersInShopData" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('shop.add_users') }}</h5>

              <!--begin::Close-->
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                      fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                      fill="currentColor" />
                  </svg>
                </span>
                <!--end::Svg Icon-->
              </div>

              <!--end::Close-->
            </div>
            <div class="modal-body">

              <div class="row ">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{ $t('shop.users') }}</span>
                </label>
                <div class="col-md-10 col-sm-12">
                  <select name="users[]" class="form-select form-select-solid kt_select2" multiple="multiple" data-control="select2"
                    v-model="formCreateData.users_id" required
                    :data-placeholder="$t('shop.user_placeholder')"
                    data-dropdown-parent="#createModal"
                    data-search="true">
                    <option value=""> {{ $t('shop.no_box') }} </option>
                    <option v-for="user in shopUsers" :key="user.id" :value="user.id">{{ user.lastname }} {{ user.firstname }} </option>
                  </select>
                </div>
                <div class="col-md-2 col-sm-12">
                  <div class=" input-group-append">

                    <!-- bouton grisé : le clic sur l'enveloppe dit pourquoi (limite de l'abonnement) -->
                    <span class="d-inline-block" @click="isUserLimitReached && showLimitHint()">
                    <button @click="openCreateUserModal" type="button" class="btn btn-sm btn-icon btn-light-primary"
                      style="width: 40px;height: 41px"
                      :disabled="isUserLimitReached">
                      <!--begin::Svg Icon | path: icons/duotune/arrows/arr088.svg-->
                      <span class="svg-icon svg-icon-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="300" viewBox="0 0 24 24" fill="none">
                          <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)"
                            fill="currentColor" />
                          <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor" />
                        </svg>
                      </span>
                      <!--end::Svg Icon-->
                    </button>
                    </span>
                  </div>
                </div>
              </div>
              <!-- clic sur « + » grisé : pourquoi (limite de l'abonnement) -->
              <LimitReachedBanner
                  v-if="showLimitBanner && isUserLimitReached"
                  class="mt-4"
                  :message="$t('user.limit_reached_banner', { count: societyActiveUsersCount, limit: usersLimit })"
                  :ticket-message="$t('limit_banner.ticket_users', { limit: usersLimit })"
                  @close="showLimitBanner = false"
              />

              <!-- Rôle par boutique : vide = chacun garde son rôle général dans cette boutique -->
              <div class="row mt-5">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">{{ $t('shop.user_shop_role') }}</label>
                <div class="col-md-10 col-sm-12">
                  <select class="form-select form-select-solid" v-model="formCreateData.role_id">
                    <option value="">{{ $t('shop.user_general_role') }}</option>
                    <option v-for="role in shopRoles" :key="role.id" :value="role.id">{{ role.name }}</option>
                  </select>
                  <div class="text-muted fs-7 mt-1">{{ $t('shop.user_shop_role_hint') }}</div>
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
              <button type="submit" id="kt_submit_create_shop_user" class="btn btn-sm btn-primary fw-bolder">
                <span class="indicator-label">{{ $t('button.save') }}</span>
                <span class="indicator-progress">{{ $t('loading') }}
                  <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>



    <div class="modal fade" tabindex="-1" id="createUserModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('button.add') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-2x"></span>
            </div>
          </div>
          <div class="modal-body">
            <form id="kt_modal_new_target_form" @submit.prevent="createUserData" class="form">
              <div class="d-flex flex-column mt-5 mb-8 fv-row">
                <!--begin::Label-->
                <label class="required d-flex align-items-center fs-6  fw-bold mb-2">
                  <span class="">{{$t('user.gender')}}</span>
                </label>
                <!--end::Label-->
                <div class="row">
                  <div class="col-md-12 col-sm-12" >
                    <select required name="gender" class="form-select form-select-solid kt_select2"
                            v-model="formCreateUserData.gender "  data-control="select2"
                            :data-dropdown-parent="'#createUserModal'"
                            data-search="true"
                            :data-placeholder="$t('user.civility')" >
                      <option value="female">{{ $t('user.female') }}</option>
                      <option value="male">{{ $t('user.male') }}</option>

                    </select>
                  </div>
                </div>

              </div>

              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{ $t('user.lastname') }}</span>
                </label>
                <input type="text" required class="form-control form-control-solid" v-model="formCreateUserData.lastname"
                  :placeholder="$t('user.lastname_placeholder')" />
              </div>
              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{ $t('user.firstname') }}</span>
                </label>
                <input type="text" required class="form-control form-control-solid" v-model="formCreateUserData.firstname"
                       :placeholder="$t('user.firstname_placeholder')" />
              </div>
              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{ $t('user.email') }}</span>
                </label>
                <input type="email" required class="form-control form-control-solid" v-model="formCreateUserData.email"
                  :placeholder="$t('user.email_placeholder')" />
              </div>
              <InputTel
                  name="newUserPhone"
                  type="text"
                  :label="$t('user.phone')"
                  containerClass="d-flex flex-column mb-8 fv-row"
                  labelClass="fs-6 fw-bold mb-2"
                  inputClass="form-control form-control-sm form-control-solid"
                  v-model:phone="formCreateUserData.phone"
                  v-model:phone-code="formCreateUserData.phone_code"
                  :placeholder="$t('enter_phone')"
                  :isRequired="true" />

              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{ $t('user.right') }}</span>
                </label>
                <div class="row">
                  <div class="col-md-10 col-sm-12">
                    <select name="role" class="form-select form-select-solid kt_select2" data-control="select2"
                      :data-placeholder="$t('user.role_placeholder')"
                      data-dropdown-parent="#createUserModal"
                      data-search="true">
                      <option value=""></option>
                      <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-2 col-sm-12">
                    <div class=" input-group-append">
                      <button @click="openCreateRightModal" type="button" class="btn btn-sm btn-icon btn-light-primary"
                        style="width: 40px;height: 41px">
                        <span class="svg-icon svg-icon-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="300" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)"
                              fill="currentColor" />
                            <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor" />
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <!--begin::Alert-->
                  <div style="background-color: #d8f6cc!important;" class="alert alert-dismissible bg-light d-flex flex-column flex-sm-row p-5 mb-10 mt-6">
                    <!--begin::Icon-->
                    <!--end::Icon-->

                    <!--begin::Wrapper-->
                    <div class="d-flex flex-column pe-0 pe-sm-10">
                      <!--begin::Title-->
                      <!--end::Title-->
                      <!--begin::Content-->
                      <span> {{$t('user.alert_password')}}</span>
                      <!--end::Content-->
                    </div>
                    <!--end::Wrapper-->
                    <button type="button" class="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto" data-bs-dismiss="alert">
                      <i class="bi bi-x fs-1 text-primary"></i>
                    </button>
                    <!--begin::Close-->

                    <!--end::Close-->
                  </div>
                  <!--end::Alert-->
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close')
                }}</button>
                <button type="submit" id="kt_submit_create_add_user" class="btn btn-sm btn-primary fw-bolder">
                  <span class="indicator-label">{{ $t('button.save') }}</span>
                  <span class="indicator-progress">{{ $t('loading') }}
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="createRightModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('button.add') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-2x"></span>
            </div>
          </div>
          <div class="modal-body">
            <form id="kt_modal_new_target_forma" @submit.prevent="createRightData" class="form">
              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{ $t('right.name') }}</span>
                </label>
                <input type="text" required class="form-control form-control-solid" v-model="formCreateRightData.name"
                  :placeholder="$t('right.name_placeholder')" />
              </div>
              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span>{{ $t('right.description') }}</span>
                </label>
                <input type="text" class="form-control form-control-solid" v-model="formCreateRightData.description"
                  :placeholder="$t('right.description_placeholder')" />
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close')
                }}</button>
                <button type="submit" id="kt_submit_create_add_right" class="btn btn-sm btn-primary fw-bolder">
                  <span class="indicator-label">{{ $t('button.save') }}</span>
                  <span class="indicator-progress">{{ $t('loading') }}
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Rôle d'un collaborateur dans cette boutique -->
    <div class="modal fade" id="shopRoleModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <form @submit.prevent="saveShopRole" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('shop.user_shop_role') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="fw-bold fs-6 mb-4">{{ formShopRoleData.name }}</div>
              <select class="form-select form-select-solid" v-model="formShopRoleData.role_id">
                <option value="">{{ $t('shop.user_general_role') }}</option>
                <option v-for="role in shopRoles" :key="role.id" :value="role.id">{{ role.name }}</option>
              </select>
              <div class="text-muted fs-7 mt-1">{{ $t('shop.user_shop_role_hint') }}</div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
              <button type="submit" id="kt_submit_shop_role" class="btn btn-sm btn-primary fw-bolder">
                <span class="indicator-label">{{ $t('button.save') }}</span>
                <span class="indicator-progress">{{ $t('loading') }}
                  <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {VueTelInput} from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css';
import { BASE_URL } from "@/services/api";
import {updateUserInShop} from "@/store/modules/shop/actions";
import InputTel from "@/components/InputTel.vue";
import LimitReachedBanner from "@/components/LimitReachedBanner.vue";

export default {
  components: {InputTel, VueTelInput, LimitReachedBanner},
  props: {
    shop: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      formCreateData: {
        users_id: [],
        role_id: '',
        id: this.$route.params.id,
      },
      // rôle d'un collaborateur dans cette boutique ('' = son rôle général)
      formShopRoleData: {
        id: null,
        name: '',
        role_id: '',
      },
      formUserDeleteData: {
        id: null,
        row: null
      },
      formCreateUserData: {
        gender: '',
        lastname: '',
        firstname: '',
        email: '',
        phone: '',
        phone_code:'',
        role: null,
        shop_id: ''
      },

      formCreateRightData: {
        name: '',
        description: '',
      },
      isLoading: false,
      shopData: {},
      shopUsers: [],
      shopUsersCount: 0,
      // limite d'utilisateurs de l'abonnement (0 = illimité) et utilisateurs actifs de la
      // société, toutes boutiques confondues
      usersLimit: 0,
      societyActiveUsersCount: 0,
      showLimitBanner: false
    }

  },

  watch: {
    '$i18n.locale' : function(value){
      if(value && this.table){
        this.$nextTick(() =>   this.fetchDatas())
    }
  },

    // Ce composant est monté une seule fois pour la route 'shop-users' ;
    // naviguer d'une boutique à l'autre (même route, :id différent) ne
    // remonte pas le composant, donc sans ce watcher shopUsers/shopData et
    // le datatable restaient ceux de la boutique précédente — on voyait un
    // collaborateur d'une autre boutique dans "Ajouter des collaborateurs".
    '$route.params.id': function (newId, oldId) {
      if (!newId || newId === oldId) return
      this.formCreateData.id = newId
      this.fetchDatas()
      this.initShopUser()
    },
  },

  computed: {
    // rôles attribuables dans une boutique : propriétaire et Super Admin ont tous les droits partout
    shopRoles() {
      return (this.roles || []).filter(role => !['Super Admin', 'Owner'].includes(role.name))
    },
    ...mapGetters('role', [
      'roles',
    ]),
    ...mapGetters('user', [
      'currentUser'
    ]),

    options(){
      return {
        placeholder: i18n.global.t('enter_phone'),
        showDialCode : true
      }
    },

    // La limite porte sur l'abonnement de la société, toutes boutiques confondues
    isUserLimitReached(){
      return this.usersLimit > 0 && this.societyActiveUsersCount >= this.usersLimit
    },
  },
  async mounted() {

    this.fetchDatas()
    this.loadRole()
    await this.initShopUser()

    $(document).off("click", "#kt_datatable_shop_user .role_btn")
    $(document).on("click", "#kt_datatable_shop_user .role_btn", (e) => {
      const button = e.currentTarget
      this.formShopRoleData = {
        id: button.dataset.id,
        name: button.dataset.name,
        role_id: button.dataset.role || '',
      }
      $('#shopRoleModal').modal('show')
    })
    $(document).on("click", "#kt_datatable_shop_user .delete_btn", (e) => {
      this.formUserDeleteData.id = e.target.getAttribute('data-id')
      this.formUserDeleteData.row = e.target.getAttribute('data-row')
      this.removeUserRow()
    });

    this.initSelect2()
  },
  methods: {
    showLimitHint() {
      this.showLimitBanner = true
    },

    ...mapActions('shop', [
      'addUsersInShop',
      'updateUserShopRole',
      'updateUserInShop',
      'showShop',
      'removeUserFromShop'
    ]),
    ...mapActions('user', [
      'createUser'
    ]),

    ...mapActions('role', [
      'loadRole',
      'createRole'
    ]),

    openCreateRightModal() {
      $('#createRightModal').modal('toggle')
    },

    async initShopUser(){
      let response = await this.showShop(this.$route.params.id)
      this.shopData = response.data.shop
      this.shopUsers = response.data.shopUsers
      this.shopUsersCount = response.data.shopUsersCount
      this.usersLimit = response.data.usersLimit ?? 0
      this.societyActiveUsersCount = response.data.societyActiveUsersCount ?? 0
    },

    thirstInputCountryChanged(country) {
      this.formCreateUserData.phone = '+' + country.dialCode
      this.formCreateUserData.phone_code = '+' + country.dialCode
    },

    thirstInputChanged(number, phoneObject) {
      let errorDiv = document.querySelector('[data-field="shop_phone"][data-field="shop_phone"][data-validator="callback"]')
      if (errorDiv) {
        errorDiv.remove()
      }

      if (phoneObject) {
        this.formCreateUserData.phone = phoneObject.nationalNumber
        this.formCreateUserData.phone = '+' + phoneObject.countryCallingCode
      }
    },

    fetchDatas() {
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_shop_user").DataTable({
        destroy:true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength: Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        order: [[0, 'asc']],
        ajax: {
          url: BASE_URL + '/get/shop/' + this.$route.params.id + '/users/datatables',
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data: function (d) {

          }
        },
        columns: [{ data: "lastname" }, { data: "firstname" },{ data: "role" }, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [

          {
            targets: -4,
            order: "desc",
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              return '<span data-id="' + e.id + '" class="amountRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -3,
            order: "desc",
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              return '<span data-id="' + e.id + '" class="amountRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -2,
            order: "desc",
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              let render = ""
              if(e.role){
                render = '<span class="badge badge-light-primary fs-7 fw-bold" data-id="' + e.id + '">' + t + "</span>";
              }
              // rôle propre à cette boutique (sinon c'est son rôle général)
              if(e.shop_role_id){
                render += ' <span class="badge badge-light-primary ms-1">' + i18n.global.t('shop.user_role_specific') + '</span>';
              }
              return render
            },
          },


          {
            width: "10%",
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {

              let render = ""
              if (!this.shopData?.archive) {
                // Rôle dans cette boutique (pas le sien : voir ShopUserController::updateUserShopRole)
                if(this.$can('user_boutique_update') && e.id !== this.currentUser?.id){
                  render += '<button type="button" data-id="' + e.id + '" data-role="' + (e.shop_role_id || '') + '" data-name="' + this.escapeAttribute(e.lastname + ' ' + e.firstname) + '" class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto role_btn" title="' + i18n.global.t('shop.user_shop_role') + '">' +
                      '<i class="bi bi-person-gear fs-4"></i>' +
                      '</button> '
                }
                // Se retirer soi-même de sa seule boutique coupe tout accès
                // (plus de shop_id/pivot = 403 partout) — voir le contrôle
                // backend jumeau dans ShopUserController::removeUsersFromShop.
                if(this.$can('user_boutique_delete') && e.id !== this.currentUser?.id){
                  render += '<button type="button" data-row="' + l.row + '" data-id="' + e.id + '" class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto delete_btn" title="' + i18n.global.t('button.delete') + '">' +
                      '<i data-row="' + l.row + '" data-id="' + e.id + '"   class="fa fa-trash-alt"></i>' +
                      '</button> '
                }

              }
              return render

            },
          },

        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json",
        }
      });
    },

    openCreateModal() {
      $('#createModal').modal('toggle')
    },

    openEditModal() {
      $('#editModal').modal('toggle')
      this.$nextTick(() => {
        this.initSelect2()
      })
    },

    initSelect2() {
      $("body .kt_select2").select2()
      $("body .kt_select2").select2().select2()
      $("body .kt_select2").change((e) => {
        switch (e.target.name) {
          case 'users[]':
            let users = [];
            for (var k = 0, kLen = e.target.selectedOptions.length; k<kLen; k++) {
              if(e.target.selectedOptions[k].value != '' || e.target.selectedOptions[k].value != undefined){
                users.push(e.target.selectedOptions[k].value);
              }
            }
            this.formCreateData.users_id = users
            break;
          case 'role':
            this.formCreateUserData.role = e.target.value
            break;
          case 'gender':
            this.formCreateUserData.gender = e.target.value
            break;
          default:
            break;
        }
      })
    },

    openCreateBoxModal() {
      $('#createBoxModal').modal('toggle')
    },

    openCreateUserModal() {
      $('#createUserModal').modal('toggle')
    },

    escapeAttribute(value) {
      return String(value ?? '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },

    async saveShopRole() {
      this.$loading('kt_submit_shop_role')
      try {
        const response = await this.updateUserShopRole({
          shop_id: this.$route.params.id,
          user_id: this.formShopRoleData.id,
          role_id: this.formShopRoleData.role_id || null,
        })
        window.toastr['success'](response.data.message)
        $('#shopRoleModal').modal('hide')
        this.table.ajax.reload()
      } catch (err) {
        window.toastr['error'](err?.response?.data?.message || i18n.global.t("notification.shop_add_user_error"))
      } finally {
        this.$stopLoading('kt_submit_shop_role')
      }
    },

    async addUsersInShopData() {
      this.$loading('kt_submit_create_shop_user')

      let response = {}
      try {
        response = await this.addUsersInShop(this.formCreateData)
        window.toastr['success'](i18n.global.t("notification.shop_add_user"))
        $('#createModal').modal('toggle')

        this.formCreateData = {
          users_id: [],
          role_id: '',
          id: this.$route.params.id,
        }

        this.$stopLoading('kt_submit_create_shop_user')
        this.table.ajax.reload()
        await this.initShopUser()


        return true
      } catch (err) {
        this.$stopLoading('kt_submit_create_shop_user')
        this.isLoading = false;
        window.toastr['error'](err?.response?.data?.message || i18n.global.t("notification.shop_add_user_error"))
      }
    },


    async removeUserRow() {
      let response = {}
      Swal.fire({
        title: i18n.global.t("shop.remove_user"),
        text: i18n.global.t("shop.action_irreversible"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
      }).then(async (result) => {
        if (result.value) {
          try {
            let data = {
              id: this.formUserDeleteData.id,
              shop_id: this.$route.params.id
            }
            response = await this.removeUserFromShop(data)
            window.toastr['success'](i18n.global.t("notification.shop_user_removed"))
            this.table.ajax.reload()
            await this.initShopUser()

          } catch (e) {

          }
        }
      });
    },



    async createUserData() {
      this.$loading('kt_submit_create_add_user')
      let data = {
        gender: this.formCreateUserData.gender,
        lastname: this.formCreateUserData.lastname,
        firstname: this.formCreateUserData.firstname,
        email: this.formCreateUserData.email,
        phone: this.formCreateUserData.phone,
        phone_code: this.formCreateUserData.phone_code,
        role: this.formCreateUserData.role,
        // Boutique affichée (et non la boutique active, réservée à l'interface de vente)
        shop_id: this.$route.params.id,
      }
      let response = {}
      try {
        response = await this.createUser(data)
        window.toastr['success'](i18n.global.t("notification.user_created"))
        $('#createUserModal').modal('toggle')

        this.table.ajax.reload()

        this.formCreateUserData = {
          gender: '',
          lastname: '',
          firstname: '',
          email: '',
          phone: '',
          phone_code: '',
          profile: '',
        }
        this.$stopLoading('kt_submit_create_add_user')
        this.formCreateData.users_id.push(response.data.user.id)
        await this.initShopUser()
        return true
      } catch (err) {
        this.$stopLoading('kt_submit_create_add_user')
        this.isLoading = false;
        window.toastr['error'](err?.response?.data?.message || i18n.global.t("notification.user_created_error"))
      }
    },

    async createRightData() {
      this.$loading('kt_submit_create_add_right')
      let data = {
        name: this.formCreateRightData.name,
        description: this.formCreateRightData.description
      }
      let response = {}

      try {
        response = await this.createRole(data)
        this.loadRole()
        this.formCreateData.role = response.data.role.id
        window.toastr['success'](i18n.global.t("notification.right_created"))

        $('#createRightModal').modal('toggle')
        this.formCreateRightData = {
          name: '',
          description: '',
        }
        this.$stopLoading('kt_submit_create_add_right')
        return true
      } catch (err) {
        this.$stopLoading('kt_submit_create_add_right')
        this.isLoading = false;
      }
    },
  },
}
</script>

<style scoped></style>
